export default "__VITE_ASSET__d5df4c7c__"